import axios from 'axios';
import { Partner } from '../../types/PartnerTypes';
import { clientVitalsAPI } from 'src/utils/secrets';


const API_BASE_URL = clientVitalsAPI || 'http://localhost:4000';


export class PartnerApi {
  private baseUrl: string;


  constructor(baseUrl: string = API_BASE_URL) {
    this.baseUrl = baseUrl;
  }


  async getAllPartners(filters?: { category?: string; region?: string }): Promise<Partner[]> {
    try {
      const params = new URLSearchParams();
      if (filters?.category) params.append('category', filters.category);
      if (filters?.region) params.append('region', filters.region);


      const url = `${this.baseUrl}/dynamo/trusted-partners/fetch${params.toString() ? `?${params}` : ''}`;
      
      const response = await axios.get(url);
      console.log({response: response?.data?.result?.Items})

      return response?.data?.result?.Items || [];
    } catch (error) {
      console.error('Error fetching partners:', error);
      throw new Error('Failed to load partners. Please try again later.');
    }
  }

  async getPartnerById(partnerId: string): Promise<Partner> {
    try {
      const response = await axios.get(`${this.baseUrl}/trusted-partners/${partnerId}`);
      
      if (!response.data.success) {
        throw new Error('Failed to fetch partner');
      }

      return response.data.partner;
    } catch (error) {
      console.error('Error fetching partner:', error);
      throw new Error('Failed to load partner details.');
    }
  }

  async submitPartnerApplication(application: any): Promise<Partner> {
    try {
      const response = await axios.post(`${this.baseUrl}/trusted-partners/apply`, application);
      
      if (!response.data.success) {
        throw new Error(response.data.message || 'Failed to submit application');
      }


      return response.data.partner;
    } catch (error: any) {
      console.error('Error submitting application:', error);
      throw new Error(error.response?.data?.message || 'Failed to submit application. Please try again.');
    }
  }
}


export const partnerApi = new PartnerApi();


